import { AxiosRequestConfig } from 'axios';
import axios from './axiosInstance';
import { PaginatedResponse } from './types';

export function createCrudApi<
  TItem,
  TFormData,
  TGetParams extends Record<string, unknown> = Record<string, unknown>
>(endpoint: string) {
  return {
    get: (params?: TGetParams, config?: AxiosRequestConfig) =>
      axios.get<PaginatedResponse<TItem>>(endpoint, { params, ...config }),

    post: (data: TFormData) => axios.post<TItem>(endpoint, data),

    getOneById: (id: number) => axios.get<TItem>(`${endpoint}${id}/`),

    put: (id: number, data: TFormData) => axios.put<TItem>(`${endpoint}${id}/`, data),

    patch: (id: number, data: Partial<TFormData>) => axios.patch<TItem>(`${endpoint}${id}/`, data),

    remove: (id: number) => axios.delete<void>(`${endpoint}${id}/`)
  };
}

export type CrudApi<
  TItem,
  TFormData,
  TGetParams extends Record<string, unknown> = Record<string, unknown>
> = ReturnType<typeof createCrudApi<TItem, TFormData, TGetParams>>;
